import React, { useState } from 'react';
import { Brain, Crown, Zap, Rocket, ChevronDown, Check } from 'lucide-react';

const ModelSelector = ({ selectedModel, onModelChange, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const models = {
    'claude-sonnet-3.5': {
      name: 'Claude 3.5 Sonnet',
      provider: 'VPS Personnel',
      icon: Brain,
      description: 'Votre Claude actuel (VPS)',
      color: 'from-purple-500 to-pink-600',
      badge: 'Actuel',
      badgeColor: 'bg-purple-500'
    },
    'claude-opus-4': {
      name: 'Claude 4 Opus',
      provider: 'OpenRouter',
      icon: Crown,
      description: 'Le plus puissant de Claude',
      color: 'from-yellow-500 to-orange-600',
      badge: 'Premium',
      badgeColor: 'bg-yellow-500'
    },
    // ✅ NOUVEAUX MODÈLES AJOUTÉS
    'chatgpt-4o': {
      name: 'ChatGPT-4o',
      provider: 'OpenRouter',
      icon: Brain, // ou importez un autre icône si vous voulez
      description: 'OpenAI GPT-4o dernière version',
      color: 'from-green-500 to-teal-600',
      badge: 'OpenAI',
      badgeColor: 'bg-green-500'
    },
    'zephyr-141b': {
      name: 'Zephyr 141B-A35B',
      provider: 'OpenRouter',
      icon: Zap,
      description: 'Zephyr ultra-performant 141B',
      color: 'from-indigo-500 to-purple-600',
      badge: 'Ultra',
      badgeColor: 'bg-indigo-500'
    },
    'llama-4-maverick': {
      name: 'Llama 4 Maverick',
      provider: 'OpenRouter',
      icon: Zap,
      description: 'Meta Llama dernière génération',
      color: 'from-blue-500 to-cyan-600',
      badge: 'Nouveau',
      badgeColor: 'bg-blue-500'
    },
    'qwen-2.5-72b': {
      name: 'Qwen 2.5 72B',
      provider: 'OpenRouter',
      icon: Rocket,
      description: 'Alibaba Qwen ultra-performant',
      color: 'from-green-500 to-emerald-600',
      badge: 'Rapide',
      badgeColor: 'bg-green-500'
    }
  };

  const selectedModelData = models[selectedModel] || models['claude-sonnet-3.5'];
  const IconComponent = selectedModelData.icon;

  return (
    <div className="relative">
      <button
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className={`w-full flex items-center justify-between p-4 bg-gradient-to-r ${selectedModelData.color} rounded-xl text-white font-medium transition-all duration-200 ${
          disabled 
            ? 'opacity-50 cursor-not-allowed' 
            : 'hover:shadow-lg hover:scale-105 cursor-pointer'
        }`}
      >
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
            <IconComponent className="w-5 h-5" />
          </div>
          <div className="text-left">
            <div className="font-bold text-lg">{selectedModelData.name}</div>
            <div className="text-white/80 text-sm">{selectedModelData.provider}</div>
          </div>
          <div className={`px-2 py-1 ${selectedModelData.badgeColor} rounded-full text-xs font-bold`}>
            {selectedModelData.badge}
          </div>
        </div>
        <ChevronDown className={`w-5 h-5 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && !disabled && (
  <div className="absolute top-full left-0 right-0 mt-2 bg-gray-800/95 backdrop-blur-xl border border-white/20 rounded-xl shadow-2xl z-50 overflow-hidden">
    {/* ✅ AJOUTER max-height et overflow-y-auto pour le scroll */}
    <div className="max-h-80 overflow-y-auto custom-scrollbar">
      {Object.entries(models).map(([key, model]) => {
        const ModelIcon = model.icon;
        const isSelected = key === selectedModel;
        
        return (
          <button
            key={key}
            onClick={() => {
              onModelChange(key);
              setIsOpen(false);
            }}
            className={`w-full flex items-center space-x-3 p-4 text-left transition-all hover:bg-white/10 ${
              isSelected ? 'bg-white/5' : ''
            }`}
          >
            <div className={`w-10 h-10 bg-gradient-to-r ${model.color} rounded-lg flex items-center justify-center`}>
              <ModelIcon className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1">
              <div className="flex items-center space-x-2">
                <span className="text-white font-medium">{model.name}</span>
                <span className={`px-2 py-1 ${model.badgeColor} rounded-full text-xs font-bold text-white`}>
                  {model.badge}
                </span>
                {isSelected && <Check className="w-4 h-4 text-green-400" />}
              </div>
              <div className="text-gray-400 text-sm">{model.description}</div>
              <div className="text-gray-500 text-xs">{model.provider}</div>
            </div>
          </button>
        );
      })}
    </div>
  </div>
)}
    </div>
  );
};

export default ModelSelector;